import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useRef, useState, useCallback, useEffect } from 'react';
import _ from 'lodash';
import { animated, useTransition } from 'react-spring';
import useElementDimensions from '../../../hooks/useElementDimensions';
const FadeInOut = ({ children, isVisible = false, duration = 300, style = {}, className = '', }) => {
    const transitions = useTransition(isVisible, {
        from: { opacity: 0 },
        enter: { opacity: 1 },
        leave: { opacity: 0 },
        config: { duration },
    });
    return (_jsx(_Fragment, { children: transitions((styleTransition, item) => item ? (_jsx(animated.div, { style: { ...styleTransition, ...style }, className: className, children: children })) : null) }));
};
const Transition = ({ children, isVisible = false, from, enter, leave, config, update, onRest, style = {}, }) => {
    const transitions = useTransition(isVisible, {
        from,
        enter,
        leave,
        config,
        update,
        onRest,
    });
    return (_jsx(_Fragment, { children: transitions((styleTransition, item) => item ? (_jsx(animated.div, { style: { ...styleTransition, ...style }, children: children })) : null) }));
};
const FadeInOutWithHeight = ({ children, isVisible = false, duration = 300, style = {}, className = '', height = 0, }) => {
    const ref = useRef(null);
    const dimensions = useElementDimensions(ref);
    const [_height, setHeight] = useState(height);
    const [_width, setWidth] = useState(0);
    const setNewHeight = useCallback(() => {
        const debouncedSetHeight = _.debounce(() => {
            if (isVisible && ref.current) {
                const measuredHeight = Math.max(ref.current.offsetHeight, ref.current.childNodes[0]?.offsetHeight, ref.current.childNodes[0]
                    ?.childNodes[0]?.offsetHeight);
                if (measuredHeight !== _height) {
                    setHeight(measuredHeight);
                }
            }
        }, 400);
        debouncedSetHeight();
    }, [_height, isVisible]);
    useEffect(() => {
        if (dimensions?.width !== _width) {
            setWidth(dimensions?.width || 0);
            setNewHeight();
        }
    }, [_width, dimensions?.width, setNewHeight]);
    const transitions = useTransition(isVisible, {
        from: { opacity: 0, height: 0 },
        enter: { opacity: 1, height: _height },
        leave: { opacity: 0, height: 0 },
        config: { duration },
        onRest: () => {
            setNewHeight();
        },
        update: { height: _height },
    });
    return (_jsx(_Fragment, { children: transitions((styleTransition, item) => item ? (_jsx(animated.div, { ref: ref, style: {
                ...(styleTransition?.height?.animation?.values[0]?.done
                    ? {}
                    : styleTransition),
                ...style,
            }, className: className, children: children })) : null) }));
};
const Animate = {
    FadeInOut,
    Transition,
    FadeInOutWithHeight,
};
export default Animate;
//# sourceMappingURL=index.js.map